export default __webpack_public_path__ + "static/media/KNS.846f7da8.jpeg";